import React from 'react'
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { COLORS_PROJECT, DEFAULT_CIRCLE_SIZE_PIXELS } from '../../../constants';
import Circle from '../../ui/Circle';

export const IconSwitch = ({number,sizePixels=DEFAULT_CIRCLE_SIZE_PIXELS}) => {

    const {color_alarm_grey}=COLORS_PROJECT; //color_alarm_green,
    const {colorPoints} = useSelector(state => state.auth)
    const arrColors = colorPoints.split(",")
    if (number===4) {
        return (<Circle color={color_alarm_grey} sizePixels={sizePixels} />);
    }else if(number!==4){
        return (<Circle color={arrColors[0]} sizePixels={sizePixels}/>);
    } else {
        return <Circle color={color_alarm_grey} sizePixels={sizePixels}/>;
    }
}

IconSwitch.propTypes = {
    number: PropTypes.number.isRequired,
    sizePixels: PropTypes.number,
};
